import React from 'react';

import g from 'glamorous';

const styleText = `transform: translateZ(0px);
filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.75));`;

export default () => (
  <div>
    <p>Below this is a 200 x 200 div with red background and both of the following styles applied:</p>
    <g.Pre fontFeatureSettings='"kern"'>{styleText}</g.Pre>
    <g.Div
      marginTop="24px"
      width="200px"
      height="200px"
      backgroundColor="red"
      transform="translateZ(0px)"
      filter="drop-shadow(0 4px 8px rgba(0, 0, 0, 0.75))"
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/drop-shadow-test.js